import React, { useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa";
import { API_BASE } from "../config";



export function UtilisateursAdmin({ user }) {
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [q, setQ] = React.useState("");
  const [role, setRole] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [total, setTotal] = React.useState(0);
  const limit = 20;

  const [confirm, setConfirm] = React.useState(null);
  const [success, setSuccess] = useState("");
  const [actionLoading, setActionLoading] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const showToast = (type, msg) => {
    setToast({ type, msg });
    setTimeout(() => setToast({ type: "", msg: "" }), 3200);
  };
  const [toast, setToast] = useState({ type: "", msg: "" });


  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line
  }, []);
  

  const fetchUsers = async () => {
    setLoading(true);
    setError("");
    try {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("limit", String(limit));
      if (q.trim()) params.set("q", q.trim());
      if (role) params.set("role", role);

      const res = await fetch(`${API_BASE}/admin/utilisateurs?${params.toString()}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.msg || "Erreur lors du chargement");
      } else {
        setItems(data.items || []);
        setTotal(data.total || 0);
      }
    } catch {
      setError("Impossible de contacter le serveur.");
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line
  }, [page, role]);

  const pages = Math.max(1, Math.ceil(total / limit));

  const askToggle = (u) => {
    setConfirm({
      type: "toggle",
      id: u.id,
      email: u.email,
      nextActif: !u.actif,
    });
  };

  const doDelete = async () => {
    if (!deleteConfirm) return;
    setDeleteLoading(true);
    try {
      const res = await fetch(
        `${API_BASE}/admin/utilisateurs/${deleteConfirm.id}/archiver`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.msg || "Erreur suppression");

      setItems((prev) => prev.filter((u) => u.id !== deleteConfirm.id));
      setTotal((t) => Math.max(0, t - 1));
      showToast("success", "Utilisateur supprimé");
    } catch (e) {
      showToast("error", e.message);
    } finally {
      setDeleteLoading(false);
      setDeleteConfirm(null);
    }
  };

  const doToggle = async () => {
    if (!confirm || confirm.type !== "toggle") return;
  
    setActionLoading(true);
  
    try {
      const res = await fetch(
        `${API_BASE}/admin/utilisateurs/${confirm.id}/actif`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
          body: JSON.stringify({ actif: confirm.nextActif }),
        }
      );
  
      const data = await res.json();
  
      if (!res.ok) {
        setError(data.msg || "Erreur mise à jour");
        setSuccess("");
      } else {
        setItems((prev) =>
          prev.map((x) =>
            x.id === confirm.id ? { ...x, actif: confirm.nextActif } : x
          )
        );
  
        setError("");
        setSuccess(
          confirm.nextActif
            ? "Utilisateur activé avec succès"
            : "Utilisateur désactivé avec succès"
        );
  
        setTimeout(() => setSuccess(""), 4000);
      }
    } catch {
      setError("Impossible de contacter le serveur.");
    } finally {
      setActionLoading(false);
      setConfirm(null);
    }
  };
  

  return (
    <div className="adminPanel">
      <div className="adminPanelHeader">
        <div>
       
        </div>

        <button
          className="btnSecondary"
          onClick={async () => {
            await fetchUsers();
            showToast("success", "Liste des utilisateurs mise à jour");
          }}
          disabled={loading}
        >
            {loading ? "Chargement..." : "Rafraîchir"}
          </button>
      </div>

      <div className="adminToolbar">
        <input
          className="adminInput"
          placeholder="Rechercher par email…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setPage(1);
              fetchUsers();
            }
          }}
        />

        <select
          className="adminSelect"
          value={role}
          onChange={(e) => {
            setPage(1);
            setRole(e.target.value);
          }}
        >
          <option value="">Tous les rôles</option>
          <option value="MEDECIN">Médecin</option>
          <option value="GESTIONNAIRE">Collectivité</option>
          <option value="SUPER_ADMIN">Super Admin</option>
        </select>

        <button
          className="btnPrimary"
          onClick={() => {
            setPage(1);
            fetchUsers();
          }}
          disabled={loading}
        >
          Rechercher
        </button>
      </div>

      {error && <div className="adminError">{error}</div>}
      {success && <div className="adminSuccess">{success}</div>}
      {toast.msg && <div className={`adminToast ${toast.type}`}>{toast.msg}</div>}



      <div className="adminTableWrap">
        <table className="adminTable">
          <thead>
            <tr>
              <th>Email</th>
              <th>Rôle</th>
              <th>Statut</th>
              <th style={{ width: 220 }}>Actions</th>
              </tr>
          </thead>
          <tbody>
            {!loading && items.length === 0 && (
              <tr>
                <td colSpan={4} className="adminEmpty">
                  Aucun utilisateur.
                </td>
              </tr>
            )}

            {items.map((u) => (
              <tr key={u.id}>
                <td className="adminMono">{u.email}</td>
                <td>
                  <span className="roleBadge">{u.role}</span>
                </td>
                <td>
                  <span className={`statusBadge ${u.actif ? "on" : "off"}`}>
                    {u.actif ? "Actif" : "Inactif"}
                  </span>
                </td>
                <td style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                  <button
                    className={`toggleBtn ${u.actif ? "on" : "off"}`}
                    onClick={() => askToggle(u)}
                  >
                    {u.actif ? "Désactiver" : "Activer"}
                  </button>
                  {u.role !== "SUPER_ADMIN" && (
                    <button
                      className="btnDangerOutline"
                      onClick={() => setDeleteConfirm({ id: u.id, email: u.email })}
                      title="Supprime le compte et archive les données"
                    >
                      Supprimer
                    </button>
                  )}
                </td>

              </tr>
            ))}
          </tbody>
        </table>
        
      </div>

      <div className="adminPager">
        <button className="btnSecondary" onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1}>
          ←
        </button>
        <div className="adminPagerInfo">
          Page <b>{page}</b> / {pages} — Total: <b>{total}</b>
        </div>
        <button className="btnSecondary" onClick={() => setPage((p) => Math.min(pages, p + 1))} disabled={page >= pages}>
          →
        </button>
      </div>

      {/* Confirm modal */}
      {confirm && (
  <div className="logoutModalOverlay">
    <div className="logoutModal">
      <div className="logoutModalTitle">Confirmation</div>

      <div className="logoutModalText">
        {confirm.nextActif
          ? `Activer le compte : ${confirm.email} ?`
          : `Désactiver le compte : ${confirm.email} ?`}
      </div>

      <div className="logoutModalActions">
        <button className="btnSecondary" onClick={() => setConfirm(null)}>
          Annuler
        </button>

        <button
          className="btnDanger"
          onClick={doToggle}
          disabled={actionLoading}
        >
          {actionLoading ? "Chargement..." : "Confirmer"}
        </button>
      </div>
    </div>
  </div>
)}

      {/* MODAL SUPPRESSION */}
      {deleteConfirm && (
        <div className="logoutModalOverlay">
          <div className="logoutModal">
            <div className="logoutModalTitle">Supprimer le compte</div>
            <div className="logoutModalText">
              Le compte de <strong>{deleteConfirm.email}</strong> et toutes ses données seront
              supprimés.<br />
              L'historique sera conservé dans les <strong>Archives</strong> et pourra être restauré.
            </div>
            <div className="logoutModalActions">
              <button className="btnSecondary" onClick={() => setDeleteConfirm(null)} disabled={deleteLoading}>
                Annuler
              </button>
              <button className="btnDanger" onClick={doDelete} disabled={deleteLoading}>
                {deleteLoading ? "Suppression..." : "Confirmer la suppression"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}